import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async campanas(usuario) {
    const response = await api.post(API_URL + "campanas", usuario);
    if (response.data) return response.data;
  },

  async guardaCampana(campana) {
    const response = await api.post(API_URL + "guardaCampana", campana);
    if (response.data) return response.data;
  },

  async borraCampana(userId) {
    const response = await api.post(API_URL + "borraCampana", userId);
    if (response.data) return response.data;
  },

  async grupoTelegram(usuario) {
    const response = await api.post(API_URL + "grupoTelegram", usuario);
    if (response.data) return response.data;
  },

  async campanasTipsters() {
    const response = await api.post(API_URL + "campanas/tipsters", {});
    return response.data;
  },

  async campanasCanales(payload) {
    const response = await api.post(API_URL + "campanas/canales", payload);
    return response.data;
  },

  async exportarCampanas() {
    return await api.post(API_URL + "campanas/export", {}, { responseType: "blob" });
  },

  async landingPreview(template_id, campana_id, con_banner, tipster_landing_id = null, idioma = null) {
    const payload = { template_id };
    if (campana_id) payload.campana_id = campana_id;
    if (con_banner) payload.con_banner = true;
    if (tipster_landing_id) payload.tipster_landing_id = tipster_landing_id;
    if (idioma) payload.idioma = idioma;
    const response = await api.post(API_URL + "campana-landing/preview", payload);
    return response.data; // HTML string
  },

  async landingCatalogo(campana_id) {
    const payload = campana_id ? { campana_id } : {};
    const response = await api.post(API_URL + "campana-landing/catalogo", payload);
    return response.data;
  },

  async landingCrear(campana_id, template_id, con_banner, parametros = {}, tipster_landing_id = null, idioma = null) {
    const payload = { campana_id, template_id, ...parametros };
    if (con_banner) payload.con_banner = true;
    if (tipster_landing_id) payload.tipster_landing_id = tipster_landing_id;
    if (idioma) payload.idioma = idioma;
    const response = await api.post(API_URL + "campana-landing/crear", payload);
    return response.data;
  },

  async landingPublicar(landing_id) {
    const response = await api.post(API_URL + "campana-landing/publicar", { landing_id });
    return response.data;
  },

  async landingDetalle(landing_id) {
    const response = await api.post(API_URL + "campana-landing/detalle", { landing_id });
    return response.data;
  },

  async landingEditar(landing_id, data) {
    const response = await api.post(API_URL + "campana-landing/editar", { landing_id, ...data });
    return response.data;
  },

  async landingListar(campana_id) {
    const response = await api.post(API_URL + "campana-landing/listar", { campana_id });
    return response.data;
  },

  async landingBorrar(landing_id) {
    const response = await api.post(API_URL + "campana-landing/borrar", { landing_id });
    return response.data;
  },

  async landingVistaPrevia(landing_id) {
    const response = await api.post(API_URL + "campana-landing/vista-previa", { landing_id });
    return response.data; // HTML string
  },

  async campanaDetalle(campana_id, tipo) {
    const response = await api.post(API_URL + "campanas/detalle", { campana_id, tipo });
    return response.data;
  },

  async campanaActualizarNicks(campana_id) {
    const response = await api.post(API_URL + "campanas/actualizar-nicks", { campana_id });
    return response.data;
  },

  async campanasSimple(payload) {
    const response = await api.post(API_URL + "campanas", { ...payload, page_size: 999 });
    return response.data;
  },

  async metaParametros() {
    const response = await api.post(API_URL + "meta/parametros", {});
    return response.data;
  },

  async metaParametrosCrear(tipo, valor, label = null) {
    const payload = { tipo, valor };
    if (label) payload.label = label;
    const response = await api.post(API_URL + "meta/parametros/crear", payload);
    return response.data;
  },
};
